import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useSearchParams, useNavigate } from "react-router-dom";
import { Input, Button, List } from 'reactstrap';

//Redux
import { connect } from 'react-redux';

//Funciones
import { userRolValidation } from '../../utils/userValidation/rolValidation'

//Componentes
import Swal from 'sweetalert2';
import Loading from '../../components/modales/loadingModal';

//GCP Functions
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

//API Calls
const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const envioCorreo = functionsHttpsCallable('correos_envioCorreoContratacion');
const getAPE = functionsHttpsCallable('ape_getSolicitudPorId');
const dataListaChequeo = functionsHttpsCallable('ape_getDataListaChequeo');
//API Calls

const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ConfirmarFechaContratacion = (props) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams(); 
    const ape = searchParams.get('ape');
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [fechaHoy, setFechaHoy] = useState(new Date(Date.now()));
    const [fechaContratacion, setFechaContratacion] = useState(new Date(Date.now()));
    const [fechaMax, setFechaMax] = useState(new Date(Date.now()));
    const [fechaMin, setFechaMin] = useState(new Date(Date.now()));
    const [fechaComparacion, setFechaComparacion] = useState(new Date(new Date(Date.now()).setHours(12, 0, 0))); 
    const [dataApe, setDataApe] = useState({}); 
    const [dataLista, setDataLista] = useState(undefined); 
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function getInfoApe() {
            let body = {
                solicitudId: ape,
                cod_empr: userData.codigoEmpresa
            }
            const apeReq = await getAPE(body)
            setDataApe({ ...apeReq.data.data })
        }
        async function ape_getDataListaChequeo() {
            const req = await dataListaChequeo({
                "cod_empr": 537,
                "ape": ape
            })
            if (req.data.data[0]) setDataLista(req.data.data[0])
        };
        function getFechaMin() {
            const newDate = new Date();
            if (fechaHoy > fechaComparacion) {
                // newDate.setDate(newDate.getDate() + 2);
                newDate.setDate(newDate.getDate() + 1);
                setFechaMax(newDate)
            }
            else {
                newDate.setDate(newDate.getDate() + 1);
                setFechaMax(newDate)
            }
            return newDate
        }
        setLoading(true);
        ape_getDataListaChequeo();
        getInfoApe()
        const minDate = getFechaMin();
        setFechaMin(minDate);
        setFechaHoy(minDate);
        setFechaContratacion(minDate);
        setLoading(false);
    }, [])

    useEffect(() => {
        if (dataApe.fechaExamenesMedicos) {
            const newDate = new Date(dataApe.fechaExamenesMedicos._seconds * 1000)
            newDate.setDate(newDate.getDate() + 29);
            setFechaMax(newDate)
        }
    }, [dataApe])

    const handleUpdate = async () => {
        console.log()
        let body = {
            cod_soli: ape,
            cod_empr: userData.codigoEmpresa,
            data: {
                fechaContratacionLider: fechaContratacion.toISOString().split('T')[0],
                cmp_stat: 'VERIFICACION_DOCUMENTAL',
                cod_actu: dataApe.flujo.cedulaContratador
            },

        }
        let correoData = {
            codigoAPE: ape,
            nombre: dataLista?.nombre,
            cargo: dataApe.codigoCargo,
            fechaIngreso: fechaContratacion.toISOString().split('T')[0],
            campo: dataApe.campo,
            cedula: dataLista?.cedula,
            correo: dataLista?.correo,
            enviarA: [
                dataApe.flujo.emailReclutador,
                dataApe.flujo.emailContratador
            ],
            adjuntos: []
        }
        try {
            await actualizarAPE(body);
            await envioCorreo(correoData);
            toastSuccess('Solicitud actualizada!')
            Swal.fire({
                title: "Fecha confirmada!",
                text: `Se confirmó la fecha de ingreso para ${fechaContratacion}`,
                icon: "success"
            }).then(() => {
                navigate('/home/confirmarFechaContratacion');
            })
        }
        catch (error) {
            console.log(error)
            toastSuccess('Hubo un error!')
        }

    }

    if (loading) { return <div className={"loading-area"}> <Loading /> </div> }
    else {
        return (
            < >
                <div className='card-fecha-contratacion'>
                    <p>
                        {`Confirmar fecha contratación para el proceso ${ape}`}
                    </p>
                    <div style={{ width: '50%', marginTop: '5px' }}>
                        <List>
                            <li>
                                Nombre: {dataLista?.nombre}
                            </li>
                            <li>
                                Cedula: {dataLista?.cedula}
                            </li>
                            <li>
                                Cargo: {dataApe.codigoCargo ?? ''}
                            </li>
                            <li>
                                Campo: {dataApe.campo ?? ''}
                            </li>
                        </List>
                        <Input
                            id="fechaContratacion"
                            name="datetime"
                            // min={"2024-02-06T12:00:00.000Z"}
                            min={fechaMin ? fechaMin.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            max={fechaMax ? fechaMax.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            value={fechaContratacion ? fechaContratacion.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            // onChange={(e) => setFechaContratacion(new Date(e.target.value.toUpperCase()))}
                            onChange={(e) => {
                                try {
                                    if (!isNaN(new Date(e.target.value.toUpperCase()))) setFechaContratacion(new Date(e.target.value))
                                }
                                catch (error) {
                                    console.log(error)
                                }
                            }}
                            type="date"
                        />
                    </div>
                    <div style={{ width: '50%', marginTop: '5px', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Button color="primary" onClick={() => handleUpdate()}>
                            {'Confirmar'}
                        </Button>
                    </div>
                </div>
            </>
        )
    }
}

export default withAuthenticationRequired(connect(mapStateToProps)(ConfirmarFechaContratacion), {
    onRedirecting: () => <Loading />,
  });